export const stabilizeFilters = filters => {
  // Parse JSON strings if they were passed as strings
  const filtersObj =
    typeof filters === 'string' ? JSON.parse(filters) : filters;

  // Ensure stable query keys by sorting object keys
  const stableFilters = Object.keys(filtersObj)
    .sort()
    .reduce((obj, key) => {
      if (
        filtersObj[key] !== undefined &&
        filtersObj[key] !== null &&
        filtersObj[key] !== ''
      ) {
        obj[key] = filtersObj[key];
      }
      return obj;
    }, {});

  return stableFilters;
};
